/** Currency and duration formatters. Ported 1:1 from the marketing prototype's helpers. */

/** Whole dollars, with a leading minus for negatives: -$1,200. */
export const usd = (n: number): string =>
  (Math.round(n) < 0 ? '-' : '') + '$' + Math.abs(Math.round(n)).toLocaleString('en-US')

/** Whole dollars, unsigned. Callers supply the sign. */
export const usd0 = (n: number): string => '$' + Math.round(n).toLocaleString('en-US')

/** Signed magnitude, collapsing a rounded zero to a plain "$0" rather than "+$0". */
export const signed = (n: number, sign: '+' | '-'): string =>
  Math.round(Math.abs(n)) === 0 ? '$0' : sign + usd0(Math.abs(n))

/** A month count as prose: "under a month", "17 months", "3 years 2 months". */
export const months = (m: number): string => {
  const value = Math.max(0, m)
  if (!isFinite(value)) return 'indefinitely'
  if (value < 1) return 'under a month'
  if (value >= 600) return '50+ years'
  if (value < 24) {
    const whole = Math.round(value)
    return `${whole} ${whole === 1 ? 'month' : 'months'}`
  }
  const years = Math.floor(value / 12)
  const rest = Math.round(value % 12)
  return `${years} ${years === 1 ? 'year' : 'years'}${rest ? ` ${rest} ${rest === 1 ? 'month' : 'months'}` : ''}`
}
